<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>账期详情</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-input
                    v-model="form.woid"
                    placeholder="代采单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="商品货号：">
                  <el-input
                    v-model="form.goods_no"
                    placeholder="商品货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
            position: relative;
          "
        >
          <div v-if="resData">
            <span
              >实际回货商品&nbsp;&nbsp;（{{
                resData.supply_info.settle_date
              }}）</span
            >&nbsp;&nbsp;&nbsp;&nbsp;
            <span>{{ resData.supply_info.supply_name }}</span
            >&nbsp;&nbsp;&nbsp;&nbsp;
            <span>{{ resData.supply_info.market_name }}</span
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>{{ resData.supply_info.pgname }}</span>
          </div>
          <div style="position: absolute; right: 0">
            <!--<el-button size="small" type="warning" @click="selectAll">一键全选</el-button>-->
            <!--<el-button size="small" type="primary" @click="resetNumber">重置数量</el-button>-->
            <el-button size="small" type="success" @click="output">
              导出</el-button
            >
          </div>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <!--实际回货商品-->
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            border
            :row-class-name="tableRowClassName"
            max-height="700"
            :data="resData.settle_info"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column prop="woid" label="代采订单" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="goToWcgOrderInfo(scope.row.woid)"
                  >{{ scope.row.woid }}</el-button
                >
              </template>
            </el-table-column>
            <el-table-column prop="cg_data" label="商品图片" align="center">
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.goods_img"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="货号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="price"
              label="代采单价"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="actual_num"
              label="实际开单"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.order_num }} /
                  {{ scope.row.order_amount }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="return_num"
              label="回货数量"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.cg_sir_num + scope.row.rj_sir_num }}
                  /
                  {{
                    formatCurrency(
                      (scope.row.cg_sir_num + scope.row.rj_sir_num) *
                        scope.row.price
                    )
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="out_num"
              label="退换货出库"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{ scope.row.rj_out_num }} /
                  {{
                    formatCurrency(scope.row.rj_out_num * scope.row.price)
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="act_pay"
              label="应支付"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.should_pay_num < 0" style="color: red">
                  {{ scope.row.should_pay_num }} /
                  {{
                    formatCurrency(scope.row.should_pay_num * scope.row.price)
                  }}</span
                >
                <span v-if="scope.row.should_pay_num >= 0"
                  >{{ scope.row.should_pay_num }} /
                  {{
                    formatCurrency(scope.row.should_pay_num * scope.row.price)
                  }}</span
                >
              </template>
            </el-table-column>
            <!--<el-table-column prop="act_paied" label="实际已支付" show-overflow-tooltip align="center">-->
            <!--<template slot-scope="scope">-->
            <!--<span>{{scope.row.paid_num}} / {{formatCurrency(scope.row.paid_num * scope.row.price)}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column prop="rest_pay" label="剩余待支付" show-overflow-tooltip align="center">-->
            <!--<template slot-scope="scope">-->
            <!--<span>{{scope.row.should_pay_num - scope.row.paid_num}} / {{formatCurrency((scope.row.should_pay_num - scope.row.paid_num) * scope.row.price)}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column prop="pay" label="选择支付" show-overflow-tooltip align="center" width="120">-->
            <!--<template slot-scope="scope">-->
            <!--<el-input-number v-if="scope.row.should_pay_num - scope.row.paid_num > 0" size="mini"-->
            <!--style="width: 100px" type="waring" v-model="scope.row.pay"-->
            <!--@change="handleInputChange($event, scope.$index)" :min="0"-->
            <!--:max="scope.row.should_pay_num - scope.row.paid_num"></el-input-number>-->
            <!--<el-input-number v-if="scope.row.should_pay_num - scope.row.paid_num < 0" size="mini"-->
            <!--style="width: 100px" type="waring" v-model="scope.row.pay"-->
            <!--@change="handleInputChange($event, scope.$index)"-->
            <!--:min="scope.row.should_pay_num - scope.row.paid_num"-->
            <!--:max="0"></el-input-number>-->
            <!--<div>{{formatCurrency(scope.row.pay * scope.row.price)}}</div>-->
            <!--</template>-->
            <!--</el-table-column>-->
          </el-table>
        </div>

        <!--数据汇总-->
        <div style="margin-bottom: 0; margin-top: 35px">
          <div
            style="
              background: #f3f3f3;
              height: 50px;
              line-height: 30px;
              padding: 0 25px;
              display: flex;
              align-items: center;
              position: relative;
            "
          >
            <div>
              <span>数据汇总</span>
            </div>
          </div>
          <div v-if="resData">
            <el-table
              ref="multipleTable"
              :key="'table1'"
              v-loading="tableLoading"
              border
              :data="[resData.settle_total_info]"
              tooltip-effect="dark"
              style="width: 100%"
            >
              <el-table-column
                prop="act_pay"
                label="剩余需支付金额"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ formatCurrency(scope.row.should_pay_amount) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="chose_pay"
                label="选择支付金额"
                show-overflow-tooltip
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ formatCurrency(scope.row.choose_pay_amount) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="reject_pay"
                label="售后待抵扣商品"
                show-overflow-tooltip
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ dedStatistics1() }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="ded_num"
                label="使用抵扣"
                show-overflow-tooltip
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.choose_ded_num }} /
                    {{ formatCurrency(scope.row.choose_ded_amount) }}</span
                  >&nbsp;&nbsp;&nbsp;
                  <el-button size="small" type="warning" @click="getDedList">
                    选用抵扣</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="need_num"
                label="实需支付金额"
                show-overflow-tooltip
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{
                    formatCurrency(
                      totalPayAmount(
                        scope.row.choose_pay_amount,
                        scope.row.choose_ded_amount
                      )
                    )
                  }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!--商品抵扣-->
        <div>
          <el-dialog
            style="padding-top: 0"
            title="提示"
            :visible.sync="dialogVisible"
            width="70%"
            :before-close="handleClose"
          >
            <div style="position: relative">
              <div>
                <el-select v-model="selectField" placeholder="请选择">
                  <el-option
                    v-for="item in selectOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input
                  v-model="keyword"
                  placeholder="请输入内容"
                  style="width: 300px"
                ></el-input>
                <el-button type="success" @click="searchDedData">
                  搜 索</el-button
                >
              </div>
              <div v-if="dedList" style="margin-bottom: 0; margin-top: 35px">
                <div v-if="resData">
                  <span>{{ dedStatistics() }}</span>
                </div>
                <el-table
                  ref="multipleTable1"
                  v-loading="tableLoading"
                  border
                  type="selection"
                  :data="dedList"
                  tooltip-effect="dark"
                  style="width: 100%"
                  @selection-change="handleDedSelectionChange"
                >
                  <el-table-column label="选择" type="selection" width="55">
                  </el-table-column>
                  <el-table-column
                    prop="goods_img"
                    label="商品图片"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <div
                        v-viewer
                        style="
                          width: 40px;
                          height: 40px;
                          overflow: hidden;
                          cursor: pointer;
                          margin: auto;
                        "
                      >
                        <img
                          style="width: 100%; height: 100%"
                          :src="scope.row.goods_img"
                        />
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="goods_name"
                    label="商品名称"
                    show-overflow-tooltip
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="goods_no"
                    label="商品货号"
                    show-overflow-tooltip
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="price"
                    label="代采单价"
                    show-overflow-tooltip
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="actual_num"
                    label="待抵扣"
                    show-overflow-tooltip
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.num }} / {{ scope.row.amount }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="pay"
                    label="选择使用"
                    show-overflow-tooltip
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-input-number
                        v-model="scope.row.choose_ded_num"
                        size="small"
                        style="width: 100px"
                        type="waring"
                        :min="0"
                        :max="Number(scope.row.num)"
                        @change="handleDedInputChange($event, scope)"
                      ></el-input-number>
                    </template>
                  </el-table-column>
                </el-table>
                <div v-if="resData" style="position: absolute; right: 10px">
                  <p>
                    账单金额： 共{{
                      resData.settle_total_info.choose_pay_num
                    }}件， 计{{
                      formatCurrency(
                        resData.settle_total_info.choose_pay_amount
                      )
                    }}元
                  </p>
                  <p>
                    选用抵扣： 共{{
                      resData.settle_total_info.choose_ded_num
                    }}件， 计{{
                      formatCurrency(
                        resData.settle_total_info.choose_ded_amount
                      )
                    }}元
                  </p>
                </div>
              </div>
            </div>
            <div slot="footer" class="dialog-footer" style="margin-top: 35px">
              <el-button @click="useDedCancel">取 消</el-button>
              <el-button type="primary" @click="dialogVisible = false">
                确 定</el-button
              >
            </div>
          </el-dialog>
        </div>

        <!--收款人账户的选择 -->
        <div class="" style="margin-top: 35px">
          <div
            style="
              background: #f3f3f3;
              height: 50px;
              line-height: 30px;
              padding: 0 25px;
              display: flex;
              align-items: center;
              position: relative;
            "
          >
            <div>
              <span>收款人信息</span>
            </div>
          </div>
          <div
            v-if="resData"
            class="payee_info"
            style="margin-bottom: 0; width: 100%"
          >
            <el-table
              ref="multipleTable"
              v-loading="tableLoading"
              border
              :span-method="objectSpanMethod"
              :data="[resData.supply_bank_info]"
              tooltip-effect="dark"
            >
              <!--<el-table-column label="选择" width="50">-->
              <!--<template slot-scope="scope">-->
              <!--<div>-->
              <!--<el-radio v-model="submitData.bank_receiver" :label="scope.row.payee_id">-->
              <!--{{''}}-->
              <!--</el-radio>-->
              <!--</div>-->
              <!--</template>-->
              <!--</el-table-column>-->
              <el-table-column
                prop="payee_name"
                label="收款人名称"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="payee_bank"
                label="收款银行"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="payee_bank_account"
                label="收款账号"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="need_num"
                label="操作"
                show-overflow-tooltip
                align="center"
              >
                <template slot-scope="scope">
                  <div>
                    <el-button
                      size="small"
                      type="success"
                      @click="submitSettleData"
                      >提 交</el-button
                    >
                    <el-button
                      size="small"
                      type="primary"
                      @click="update_payee('', scope.row)"
                      >修改付款信息</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <el-dialog title="修改付款信息" :visible.sync="payVisible" width="40%">
          <el-form :model="submitData">
            <el-form-item label="收款人银行账号">
              <el-input
                v-model="submitData.pay_account"
                placeholder="请输入收款人银行账号"
                style="width: 80%; float: right"
              ></el-input>
            </el-form-item>
            <el-form-item label="收款人姓名">
              <el-input
                v-model="submitData.pay_contact"
                placeholder="请输入收款人姓名"
                style="width: 80%; float: right"
              ></el-input>
            </el-form-item>
            <el-form-item label="收款人银行">
              <el-input
                v-model="submitData.pay_bank"
                placeholder="请输入收款人银行"
                style="width: 80%; float: right"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                v-model="submitData.pay_remark"
                placeholder="请输入备注"
                style="width: 80%; float: right"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="payVisible = false">取 消</el-button>
            <el-button type="primary" @click="update_payee('post', '')">
              确 定</el-button
            >
          </div>
        </el-dialog>

        <!--账单信息-->
        <div style="margin-top: 35px">
          <div
            style="
              background: #f3f3f3;
              height: 50px;
              line-height: 30px;
              padding: 0 25px;
              display: flex;
              align-items: center;
              position: relative;
            "
          >
            <div>
              <span>账单信息</span>
            </div>
          </div>
          <div v-if="resData" style="margin-bottom: 0">
            <el-table
              ref="multipleTable"
              v-loading="tableLoading"
              border
              :data="resData.settle_bill"
              tooltip-effect="dark"
              style="width: 100%"
            >
              <el-table-column prop="bill_id" label="账单编号" align="center">
              </el-table-column>
              <el-table-column
                prop="reject_pay"
                label="实际应支付"
                show-overflow-tooltip
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.se_pay_amount }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="ded_num"
                label="使用抵扣"
                show-overflow-tooltip
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.use_ded_num }} /
                    {{ scope.row.use_ded_amount }}</span
                  >&nbsp;&nbsp;&nbsp;
                </template>
              </el-table-column>
              <el-table-column
                prop="need_num"
                label="实际支付"
                show-overflow-tooltip
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.real_pay_amount }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="need_num"
                label="支付人"
                show-overflow-tooltip
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.pay_admin }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="need_num"
                label="支付时间"
                show-overflow-tooltip
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.pay_time }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="need_num"
                label="支付凭证"
                show-overflow-tooltip
                align="center"
                width="180"
              >
                <template slot-scope="scope">
                  <div class="pay_doc" style="height: 55px">
                    <viewer class="viewer" :images="scope.row.pay_doc">
                      <img
                        v-for="src in scope.row.pay_doc"
                        :key="src"
                        :src="src"
                        style="width: 50px; height: 50px; margin-right: 10px"
                      />
                    </viewer>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="need_num"
                label="收款人信息"
                show-overflow-tooltip
                align="center"
              >
                <template slot-scope="scope">
                  <div>
                    <p>{{ scope.row.payee_name }}</p>
                    <p>{{ scope.row.payee_bank }}</p>
                    <p>
                      {{ scope.row.payee_bank_account }}
                    </p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="need_num"
                label="操作"
                show-overflow-tooltip
                align="center"
              >
                <template slot-scope="scope">
                  <span>
                    <el-button
                      type="text"
                      size="small"
                      @click="handleClick(scope.row)"
                      >详情</el-button
                    >
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!--操作日志-->
        <div class="log" style="margin-top: 35px">
          <div
            style="
              background: #f3f3f3;
              height: 50px;
              line-height: 30px;
              padding: 0 25px;
              display: flex;
              align-items: center;
              position: relative;
            "
          >
            <div v-if="resData">
              <span>操作日志</span>
            </div>
          </div>
          <div v-if="resData" style="margin-bottom: 0">
            <el-table
              ref="multipleTable"
              v-loading="tableLoading"
              border
              :data="resData.log"
              tooltip-effect="dark"
              style="width: 100%"
            >
              <el-table-column label="操作人" prop="operator" align="center">
              </el-table-column>
              <el-table-column
                prop="action_type"
                label="操作方式"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="create_time"
                label="操作时间"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="action_result"
                label="操作备注"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      keyword: "",
      selectField: "goods_name",
      selectOption: [
        { value: "goods_name", label: "商品名称" },
        { value: "goods_no", label: "商品货号" },
        { value: "goods_kh", label: "商品款号" },
      ],
      showFileList: false,
      receiptList: [],
      submitData: {
        supply_id: 0,
        settle_id: 0,
        bank_receiver: 0,
        submit_remark: "",
        dedList: [],
        chooseList: [],
      },
      showRemarkBox: false,
      dedList: [],
      originDedList: [],
      dialogVisible: false,
      resData: null,
      form: {},
      bii_form: {
        start_time: "2017-10-21",
      },
      loading: false,
      url: "/erp/SupplySettle/getSettleDetail",
      status: 100,
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      multipleSelection: [],
      originChooseList: [],
      payVisible: false,
    };
  },
  computed: {
    filteredForm() {
      const { settle_id } = this.$route.params;
      for (const key in this.form) {
        if (
          this.form[key] == undefined ||
          this.form[key] == "" ||
          this.form[key] == null
        ) {
          delete this.form[key];
        }
      }
      this.form.settle_id = settle_id;
      return this.form;
    },
  },
  methods: {
    update_payee(type, row) {
      if (type == "post") {
        // 提交修改日志
        this.$http
          .post("/erp/SupplySettle/updatePayeeLog", {
            old: this.resData.supply_bank_info,
            new_payee: this.submitData,
          })
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.resData.supply_bank_info.payee_name =
                this.submitData.pay_contact;
              this.resData.supply_bank_info.payee_bank =
                this.submitData.pay_bank;
              this.resData.supply_bank_info.payee_bank_account =
                this.submitData.pay_account;
              this.payVisible = false;
            }
          });
      } else {
        this.submitData.pay_contact = row.payee_name;
        this.submitData.pay_bank = row.payee_bank;
        this.submitData.pay_account = row.payee_bank_account;
        this.payVisible = true;
      }
    },
    dedStatistics() {
      let num = 0;
      let amount = 0.0;
      this.dedList.forEach((v) => {
        num += parseInt(v.num);
        amount += parseFloat(v.price).toFixed(2) * v.num;
      });
      this.resData.settle_total_info.rj_ded_amount = amount;
      this.resData.settle_total_info.rj_ded_num = num;
      return `共${num}件，计${parseFloat(amount).toFixed(2)}元`;
    },
    dedStatistics1() {
      let num = 0;
      let amount = 0.0;
      this.dedList.forEach((v) => {
        num += parseInt(v.num);
        amount += parseFloat(v.price).toFixed(2) * v.num;
      });
      this.resData.settle_total_info.rj_ded_amount = amount;
      this.resData.settle_total_info.rj_ded_num = num;
      return `${num} / ${parseFloat(amount).toFixed(2)}`;
    },
    //= ==========================
    /* 格式化金额 */
    formatCurrency(number) {
      let num = number.toString().replace(/\$|\,/g, "");
      if (isNaN(num)) num = "0";
      const sign = num == (num = Math.abs(num));
      num = Math.floor(num * 100 + 0.50000000001);
      let cents = num % 100;
      num = Math.floor(num / 100).toString();
      if (cents < 10) cents = `0${cents}`;
      for (let i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
        num = `${num.substring(0, num.length - (4 * i + 3))},${num.substring(
          num.length - (4 * i + 3)
        )}`;
      return `${(sign ? "" : "-") + num}.${cents}`;
    },
    /* 加法 */
    accAdd(arg1, arg2) {
      let r1;
      let r2;
      let m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = 10 ** Math.max(r1, r2);
      return (arg1 * m + arg2 * m) / m;
    },
    /* 乘法 */
    accMul(arg1, arg2) {
      let m = 0;
      const s1 = (1 * arg1).toString();
      const s2 = (1 * arg2).toString();
      try {
        m += s1.split(".")[1].length;
      } catch (e) {}
      try {
        m += s2.split(".")[1].length;
      } catch (e) {}
      const ss =
        (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) / 10 ** m;
      return Math.round(ss * 100) / 100;
    },
    /* 减法 */
    floatSub(arg1, arg2) {
      let r1;
      let r2;
      let m;
      let n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = 10 ** Math.max(r1, r2);
      // 动态控制精度长度
      n = r1 >= r2 ? r1 : r2;
      return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },
    totalPayAmount(total, used) {
      return this.floatSub(total, used);
    },
    isInteger(obj) {
      return typeof obj === "number" && obj % 1 == 0; // 是整数，则返回true，否则返回false
    },
    /* 一键全选 */
    selectAll() {
      const that = this;
      that.submitData.chooseList = [];
      let amount = 0;
      let num = 0;
      this.resData.settle_info.forEach(function (v, index) {
        const item_num = that.floatSub(
          Number(v.should_pay_num),
          Number(v.paid_num)
        );
        const item_amount = that.accMul(item_num, v.price);
        if (item_num != 0 && !isNaN(parseInt(item_num))) {
          that.resData.settle_info[index].pay = item_num;
          num += Number(item_num);
          amount += Number(item_amount);
          that.submitData.chooseList.push({
            settle_info_id: v.settle_info_id,
            num: v.pay,
          });
        }
      });
      this.resData.settle_total_info.choose_pay_num = num;
      this.resData.settle_total_info.choose_pay_amount = amount;
    },
    /* 抵扣数据搜索 */
    searchDedData() {
      if (!this.keyword) {
        return (this.dedList = this.originDedList);
      }
      const temp = [];
      this.dedList = this.originDedList;
      const field = this.selectField;
      this.dedList.forEach((v) => {
        if (field == "goods_name") {
          if (v.goods_name.indexOf(this.keyword) >= 0) {
            temp.push(v);
          }
        }
        if (field == "goods_no") {
          const m = v.goods_no.toString();
          if (m.indexOf(this.keyword) >= 0) {
            temp.push(v);
          }
        }
        if (field == "goods_kh") {
          if (v.goods_kh.indexOf(this.keyword) >= 0) {
            temp.push(v);
          }
        }
      });
      this.dedList = temp;
    },
    useDedCancel() {
      this.resData.settle_total_info.choose_ded_num = 0;
      this.resData.settle_total_info.choose_ded_amount = 0;
      this.dialogVisible = false;
      this.submitData.dedList = [];
    },
    /* 提交账单 */
    submitSettleData() {
      this.$confirm("确定提交申请？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        showInput: true,
      })
        .then((response) => {
          this.submitData.submit_remark = response.value;
          this.loading = true;
          this.showRemarkBox = false;
          this.$http
            .post("/erp/SupplySettle/generateSettleBill", this.submitData)
            .then((res) => {
              this.loading = false;
              if (res.data.code !== 200) {
                return this.$message.error(res.data.msg);
              }
              this.fetchData();
              return this.$message.success("操作成功");
            });
        })
        .catch((res) => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    cancelSettleBill(bill_id) {
      this.$confirm("确定驳回审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        showInput: true,
      })
        .then((response) => {
          this.loading = true;
          this.$http
            .post("/erp/SupplySettle/cancelSettleBill", {
              bill_id,
              reject_remark: response.value,
            })
            .then((res) => {
              this.loading = false;
              if (res.data.code !== 200) {
                return this.$message.error(res.data.msg);
              }
              this.fetchData();
              this.receiptList = [];
              return this.$message.success("操作成功");
            });
        })
        .catch((res) => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    checkPassBill(bill_id) {
      this.$confirm("确定通过审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        showInput: true,
      })
        .then((response) => {
          this.loading = true;
          this.$http
            .post("/erp/SupplySettle/checkPassBill", {
              bill_id,
              pass_remark: response.value,
            })
            .then((res) => {
              this.loading = false;
              if (res.data.code !== 200) {
                return this.$message.error(res.data.msg);
              }
              this.fetchData();
              this.receiptList = [];
              return this.$message.success("操作成功");
            });
        })
        .catch((res) => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    uploadPayDoc(bill_id) {
      if (this.receiptList.length > 3) {
        return this.$message.error("最多只能上传3张付款凭证");
      }
      if (this.receiptList.length <= 0) {
        return this.$message.error("请上传付款凭证");
      }
      this.loading = true;
      this.$http
        .post("/erp/SupplySettle/uploadPayDoc", {
          bill_id,
          doc: this.receiptList,
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            return this.$message.error(res.data.msg);
          }
          this.fetchData();
          return this.$message.success("操作成功");
        });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 4) {
        if (rowIndex % 2 == 0) {
          return {
            rowspan: 4,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    },
    handleClose(e) {
      this.dialogVisible = false;
    },
    /* 获取售后商品抵扣列表 */
    getDedList() {
      const { supply_id } = this.resData.supply_info;
      this.loading = true;
      this.$http
        .post("/erp/SupplySettle/getXhhkDedList", {
          supply_id,
        })
        .then((res) => {
          this.dialogVisible = true;
          this.loading = false;
          if (res.data.code !== 200) {
            return this.$message.error(res.data.msg);
          }
          this.dedList = res.data.data;
          this.originDedList = res.data.data;
        });
    },
    /* 选用抵扣处理 */
    handleDedSelectionChange(val) {
      const that = this;
      that.resData.settle_total_info.choose_ded_num = 0;
      that.resData.settle_total_info.choose_ded_amount = 0;
      if (val.length > 0) {
        val.forEach(function (v, index) {
          that.dedList.forEach(function (val, i) {
            if (val.woiid == v.woiid) {
              that.dedList[i].choose_ded_num = v.num;
              that.dedList[i].choose_ded_amount = that.accAdd(
                that.resData.settle_total_info.choose_ded_amount,
                v.amount
              );
            }
          });
          that.resData.settle_total_info.choose_ded_num += parseInt(v.num);
          that.resData.settle_total_info.choose_ded_amount = that.accAdd(
            that.resData.settle_total_info.choose_ded_amount,
            v.amount
          );
        });
      } else {
        that.resData.settle_total_info.choose_ded_num = 0;
        that.resData.settle_total_info.choose_ded_amount = 0;
        that.dedList.forEach(function (val, i) {
          that.dedList[i].choose_ded_num = 0;
          that.dedList[i].choose_ded_amount = 0;
        });
      }

      that.submitData.dedList = [];
      this.dedList.forEach(function (v1, index1) {
        if (v1.choose_ded_num > 0) {
          that.submitData.dedList.push({
            woiid: v1.woiid,
            num: v1.choose_ded_num,
            price: v1.price,
          });
        }
      });
    },
    /* 抵扣input处理 */
    handleDedInputChange(val, index) {
      this.dedList[index.$index].choose_ded_num = val;
      const item = this.dedList[index.$index];
      const itemamount = this.accMul(item.choose_ded_num, item.price);
      this.dedList[index.$index].choose_ded_amount = itemamount;
      if (val == 0) {
        this.$refs.multipleTable1.toggleRowSelection(index.row, false);
        return false;
      }
      if (val == this.dedList[index.$index].num) {
        this.$refs.multipleTable1.toggleRowSelection(index.row, true);
        return false;
      }
      const that = this;
      that.resData.settle_total_info.choose_ded_num = 0;
      that.resData.settle_total_info.choose_ded_amount = 0;
      that.dedList.forEach(function (v, vindex) {
        that.resData.settle_total_info.choose_ded_num += v.choose_ded_num;
        that.resData.settle_total_info.choose_ded_amount += v.choose_ded_amount;
      });
      that.submitData.dedList = [];
      this.dedList.forEach(function (v1, index1) {
        if (v1.choose_ded_num > 0) {
          that.submitData.dedList.push({
            woiid: v1.woiid,
            num: v1.choose_ded_num,
            price: v1.price,
          });
        }
      });
    },
    /* 删除回执 */
    handleRemove(index) {
      this.receiptList.splice(index, 1);
    },
    /* 上传回执成功 */
    uploadSuccess(res) {
      this.loading = true;
      const image_arr = res.data.files;
      if (this.receiptList.length > 3) {
        return this.$message.error("最多只能上传三张图片");
      }
      this.receiptList.push(image_arr[0]);
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    showDialog() {
      this.loading = true;
    },
    disapperDialog() {
      this.loading = false;
    },
    //= ==========================
    /* 不要改这里 */
    tableRowClassName(row, index) {
      row.row.index = row.rowIndex;
    },
    /* input输入框改变商品数量的处理 */
    handleInputChange(e, value) {
      const input = e;
      if (!this.isInteger(input)) {
        return this.$message.error("请选择整数");
      }
      const index = value;
      this.resData.settle_info[index].pay = input;
      const that = this;
      that.submitData.chooseList = [];
      this.resData.settle_total_info.choose_pay_num = 0;
      this.resData.settle_total_info.choose_pay_amount = 0;
      this.resData.settle_info.forEach(function (v, index) {
        if (v.pay != 0) {
          that.submitData.chooseList.push({
            settle_info_id: v.settle_info_id,
            num: v.pay,
          });
        }
        that.resData.settle_total_info.choose_pay_num += Math.abs(v.pay);
        that.resData.settle_total_info.choose_pay_amount += v.pay * v.price;
      });
    },
    /* 重置数据 */
    resetNumber() {
      const that = this;
      that.submitData.chooseList = [];
      this.resData.settle_info.forEach(function (v, index) {
        that.resData.settle_info[index].pay = 0;
      });
      this.resData.settle_total_info.choose_pay_num = 0;
      this.resData.settle_total_info.choose_pay_amount = 0;
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    fetchData(showLoading) {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.submitData.supply_id = this.resData.supply_info.supply_id;
          this.submitData.settle_id = this.form.settle_id;
          const data = this.resData.settle_info;

          /* reset data */
          this.submitData.chooseList = [];
          this.submitData.dedList = [];
          this.submitData.bank_receiver = 0;
          this.submitData.submit_remark = "";
          this.receiptList = [];
          this.resData.settle_total_info.choose_pay_num = 0;
          this.resData.settle_total_info.choose_pay_amount = 0.0;
          data.forEach((v) => {
            if (v.pay != 0) {
              this.submitData.chooseList.push({
                settle_info_id: v.settle_info_id,
                num: v.pay,
              });
            }
            this.resData.settle_total_info.choose_pay_num += Math.abs(v.pay);
            this.resData.settle_total_info.choose_pay_amount += v.pay * v.price;
          });

          const { supply_id } = this.resData.supply_info;
          this.loading = true;
          this.$http
            .post("/erp/SupplySettle/getXhhkDedList", {
              supply_id,
            })
            .then((res) => {
              this.loading = false;
              if (res.data.code !== 200) {
                return this.$message.error(res.data.msg);
              }
              this.dedList = res.data.data;
              this.originDedList = res.data.data;
            });
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleClick(row) {
      this.$router.push(`/home/OkSupplyBillDetail/${row.bill_id}`);
    },
    search() {
      this.fetchData();
    },
    selectStatus(key) {
      this.loading = true;
      this.form.status = this.status = key;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    goToWcgOrderInfo(woid) {
      this.$router.push(`/home/purchaseorderdetail/${woid}`);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.el-table__header {
  background-color: #ddd !important;
}

.el-upload-list__item-name {
  display: none !important;
}

th {
  background-color: #ddd !important;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.upload-demo ul {
  display: none !important;
}

.el-upload-list--text {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/supplybill/SupplyBillDetail.vue